import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { withTrackedSceneView } from '@portal/common/services/google-analytics';

import { getSessionAccount } from '../store/session/selectors';
import LayoutWithSidenav from './LayoutWithSidenav';
import { SIGN_IN_PATH } from './paths';

interface ProtectedRouteProps {
    onLogOut?: () => void;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ onLogOut }) => {
    const isAuthenticated = !!useSelector(getSessionAccount);
    const { pathname, search } = useLocation();

    if (!isAuthenticated) {
        const redirectPath =
            SIGN_IN_PATH +
            (onLogOut
                ? ''
                : search
                  ? `?back=${pathname}${search}`
                  : pathname !== '/'
                    ? `?back=${pathname}`
                    : '');

        return <Navigate to={redirectPath} replace />;
    }

    return (
        <LayoutWithSidenav>
            <Outlet />
        </LayoutWithSidenav>
    );
};

export default withTrackedSceneView(ProtectedRoute);
